<script>
import EntrepriseMarcheInfosStore from "@/stores/EntrepriseMarcheInfosStore";
import EntrepriseMarcheInfosTable from "@/components/EntrepriseMarcheInfos/EntrepriseMarcheInfosTable.vue";
import EntrepriseMarcheInfosSearchForm from "@/components/EntrepriseMarcheInfos/EntrepriseMarcheInfosSearchForm.vue";
import EntrepriseMarcheInfosUpdater from "@/components/EntrepriseMarcheInfos/EntrepriseMarcheInfosUpdater.vue";


export default {
  components: {
    EntrepriseMarcheInfosSearchForm,
    EntrepriseMarcheInfosTable,
    EntrepriseMarcheInfosUpdater
  },
  data: () => ({
    options: {},
    selectedRows: [],
    entrepriseMarcheInfos: {
      content: [],
      totalElements: 0
    },
  }),
  methods: {
    onSubmit(evt) {
      evt.preventDefault()
      this.search()
    },
    search(options = { searchParams: [], pageIndex: 0, pageSize: 10, sortParams: [] }) {
      this.options = Object.assign(this.options, options)
      EntrepriseMarcheInfosStore.search(this.options.searchParams, this.options.pageIndex, this.options.pageSize, this.options.sortParams)
        .then(result => {
          this.entrepriseMarcheInfos = result.data
        })
    },
    onRowSelected(rows) {
      this.selectedRows = rows
    },
    onUpdate(infos) {
      EntrepriseMarcheInfosStore.batchUpdate(this.selectedRows, infos).then(() => {
        this.search()
      })
    }
  },
  mounted() {
    this.search()
  }
}

</script>

<template>
  <div class="view">
    <h2>Rechercher une entreprise / marché infos</h2>
    <EntrepriseMarcheInfosSearchForm @search="search" class="mt-5" />
    <EntrepriseMarcheInfosUpdater :nb-elements="selectedRows.length" class="mt-5" @submit="onUpdate"
      v-if="selectedRows.length > 0" />
    <EntrepriseMarcheInfosTable class="mt-5" :data="entrepriseMarcheInfos.content" @search="search"
      @rowSelected="onRowSelected" :total-elements="entrepriseMarcheInfos.totalElements" />
  </div>
</template>
